import {Component, OnInit} from '@angular/core';
import {I18NService} from './i18n.service';
import {OverlayPanel} from "primeng/overlaypanel";

/**
 * Component.
 */
@Component({
    selector: 'i18n-selector',
    template: `
        <p-overlayPanel #op >
            <ng-template pTemplate>
                <p-button (onClick)="onChangeLang('de');op.hide();">
                    <img src="assets/images/flag-de.png"/>
                    <span class="ml-2 font-bold MarL">Deutsch</span>
                </p-button>
                <div class="EmptyBox5"></div>
                <p-button (onClick)="onChangeLang('en');op.hide();">
                    <img src="assets/images/flag-en.png"/>
                    <span class="ml-2 font-bold MarL">Englisch</span>
                </p-button>
            </ng-template>
        </p-overlayPanel>
        <img [src]="'assets/images/flag-' + i18n.lang + '.png'" (click)="op.toggle($event)"/>
    `
})
export class I18NSelectorComponent {

    languages: string[];
    selectedLang: string;

    /**
     * Constructor.
     */
    constructor(public i18n: I18NService) {
        this.languages = ["de", "en"];
        this.selectedLang = i18n.locale;
    }

    /**
     * Action.
     * @param aLang
     */
    onChangeLang(aLang: string) {
        this.selectedLang = aLang;
        this.i18n.changeLang(aLang);
        window.location.reload();
    }


}

